import { FunctionComponent } from "react";
import ReactMarkdown from "react-markdown";
import type { Schema } from "hast-util-sanitize";
import rehypeRaw from "rehype-raw";
import rehypeSanitize, { defaultSchema } from "rehype-sanitize";
import remarkBreaks from "remark-breaks";
import remarkGfm from "remark-gfm";

interface ICustomMarkdownProps {
  children: string;
  className?: string;
}

const schema: Schema = {
  ...defaultSchema,
  tagNames: [...(defaultSchema.tagNames || []), "small"],
  attributes: {
    ...defaultSchema.attributes,
    small: [...((defaultSchema.attributes && defaultSchema.attributes.small) || []), "className", "class"],
    span: [...((defaultSchema.attributes && defaultSchema.attributes.span) || []), "className", "class"],
  },
};

export const TextMarkdown: FunctionComponent<ICustomMarkdownProps> = (props: ICustomMarkdownProps) => {
  return (
    <div className={props.className}>
      <ReactMarkdown remarkPlugins={[remarkBreaks, remarkGfm]} rehypePlugins={[[rehypeRaw], [rehypeSanitize, schema]]}>
        {props.children}
      </ReactMarkdown>
    </div>
  );
};
